import { ReturnComponent } from '@/utils/reactTypes';
import { useEffect } from 'react';
import { useBlocker } from 'react-router';

/* Confirms with the user before allowing a router navigation while a dialog that guards
 * unsaved changes is open.
 *
 * This must be its own component, mounted ONLY while the dialog actually needs to
 *  block: the data router supports a single blocker at a time, and useBlocker
 *  registers itself even while its predicate is false. If every mounted dialog
 *  called useBlocker directly, any page with two or more dialogs would register
 *  multiple blockers. React Router warns ("A router only supports one blocker at
 *  a time") and only the LAST registered one works, silently disabling the
 *  protection on the dialog that needs it.
 */
export const DialogNavigationBlocker = ({
    confirmMessage,
}: {
    confirmMessage: string;
}): ReturnComponent => {
    const blocker = useBlocker(true);
    useEffect(() => {
        if (blocker.state === 'blocked') {
            const didUserConfirm = window.confirm(confirmMessage);
            if (didUserConfirm) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker, confirmMessage]);
    return null;
};
